<script>
import Main from './main.vue';

export default Main.extend({
  methods: {
    getData() {
      return new Promise((res) => {
        // Seed data
        const output = [
          {
            name: 'Quick Check',
            data: [{
              x: 0,
              y: 76,
              qa: {
                score: 76,
                level: 75,
              },
              reports: 12,
            }],
          },
          {
            name: 'Deep Scan',
            data: [{
              x: 1,
              y: 73,
              qa: {
                score: 73,
                level: 70,
              },
              reports: 5,
            }],
          },
        ];
        res(output);
      });
    },
  },
});
</script>
